<template>
   <div class="contacts"> 
      <div class=" card-default" id="card_contacts">
         <div id="contacts" class="panel-collapse collapse show" aria-expanded="true" style="">
               <div class="ative_list" v-bind:style= "[isMobile ? {'height': '90px'} : {'height':'140px'}]"  v-if="Object.keys(active()).length" >
                  <ul class="list-group pull-down" id="contact_list">
                     <li class="list-group-item"  v-for="(name, id) in active()"  :key=id>
                        <Contact @call:incoming="emit_incoming($event)"   ref="Contact" :peer="name" :id="id" :is_muted_by="muted(name.name)" :studiocaller="studiocaller" :callstate="callstate(name)" :isMobile="isMobile" />
                     </li>
                  </ul>
               </div>
               <div class="contact_list">
                  <div class="disable_layer"  v-if="active_call && isMobile && Object.keys(active()).length " ></div>
                  <ul class="list-group pull-down non_ative_list " id="contact_list">
                     <li class="list-group-item"  v-for="(name, id) in non_active()"  :key=id>
                        <Contact  :peer="name" :id="id"  :studiocaller="studiocaller" :isMobile="isMobile" :is_muted_by="{'id': '' ,'state' : 'false'}" :callstate="callstate(name)" />
                     </li>
                  </ul>
               </div>
               <p class="update_state">{{this.peerUpdate}}</p>
               <!-- {{date}} -->
               <!-- <button v-on:click="Check">
                  Test
               </button> -->
<!-- {{this.names}} -->
<!-- {{secNum}} -->
         </div>
      </div> 
   </div>
</template>

<script>

   import call_icon from "../assets/images/call.png";
   import hangup_icon from "../assets/images/hangup.png";
   import Contact from "./Contact.vue";
   
   
   export default {
      name : 'contacts',
      components: {
         Contact
      },
      props : {
         names: Object,
//          secNum : Number,
//          pUpdated : Object,
         studiocaller: Object,
         search: String,
         peerUpdate: Boolean,
         wss: Object,
         isMobile: Boolean,
         mic: GainNode,
         ctx: AudioContext,
         parentRefs: Object,
         date : Object, 
      },
      data: function () {
         return {
            test_name : this.peerUpdate,
            active_call : false,
            mute : Object,
            muted_by: {'id': '' ,'state' : 'false'},
            count: 0,
         }
      },
      beforeMount() {
         this.wss.oncallup = this._oncallup.bind(this);
         //this._oncallup();
         this.wss.oncalldown = this._oncalldown.bind(this);
         this.wss.onappmsg = this._onappmsg.bind(this);
      },
       mounted:function() {
         
       },
      methods: {
         callstate: function (p) {
            var state = '';
            var ring = false; 
            var image = '' ;
               if(p.callingus) {
                  state =  'ring_in';
                  image =  'ring_in';
                  ring = true;
               } else if(p.calledbyus) {
                  state =  "hangup" ;
                  ring = true; 
                  this.active_call = true ;
                  image =  hangup_icon;
               } else if(p.active) {
                  state =  "active_call" ;
                  image =  hangup_icon ;
                  ring = false;
               } else if(!p.active && !p.calledbyus && !p.callingus) {
                  state  = "call" ;
                  image = call_icon ;
                  ring = false;
               }
            return {
               state: state,
               image: image,
               ring: ring,
            }            
         },
         non_active : function() {
            var obj  =  { ...this.names} ;
            Object.keys(obj).forEach(key=>{
               var callstate = this.callstate(obj[key]);
               if(callstate.state == 'call') {
                  if(this.search) {
                     if(!obj[key].name.toLowerCase().includes(this.search.replace(/\s/g,'').toLowerCase() )) {
                        delete obj[key];
                     }
                  } 
               } else {
                  delete obj[key]
               }
            });
            return obj
         },
         active : function() {
            var obj  =  { ...this.names} ;
            var countNumRing = 0;
            var countNumActive = 0;
            console.log(obj); 
            
            Object.keys(obj).forEach(key=> {
               var callstate = this.callstate(obj[key]);
               if(callstate.ring) {
                  countNumRing++;
               }
               
               console.log('obj[key].active: ');
               console.log(obj[key].active);
               if(obj[key].active) {
                   countNumActive++;
               }
               
               if(callstate.state == 'hangup' || callstate.state == 'ring_in' || callstate.state == 'active_call') {
                  if(this.search) {
                     if(!obj[key].name.toLowerCase().includes(this.search.replace(/\s/g,'').toLowerCase() )) {
                        delete obj[key];
                     }
                  } 
               } else {
                  delete obj[key]
               }
            });
            

            if(countNumActive) {
               this.active_call = true ;  
            }  
             
            if(countNumRing) {
              if(this.studiocaller.ring ) {
                  console.log('Check');
                  this.studiocaller.ring.start('ring3');
               }
            } else {
                 if(this.studiocaller.ring) {this.studiocaller.ring.stop();}
            }
            return obj
         },
         print_debug : function(text) {
            this.count+=1 ;
            // this.parentRefs.debug_state.innerHTML += text +"<br/>" ;
            if(this.count > 11 ) {
               // this.parentRefs.debug_state.removeChild(this.parentRefs.debug_state.childNodes[0]);
               // this.parentRefs.debug_state.removeChild(this.parentRefs.debug_state.childNodes[0]);
            }
         },
         emit_incoming : function (updateTitle) {
           if(updateTitle) {
               this.$emit('call:incoming', updateTitle);
           }   
         },
         _oncallup(id) {
               this.active_call = true; 
               
               console.log('_oncallup : ' + id) ;
               if(this.wss._stream) {
                  console.log('ignore oncallup when in LITE mode');
                  return;
               }
               //alert("oncallup: " + id);
               if(!(id in this.wss.peers)) {
                  alert('oncallup for id ('+id+') not in peers?');
                  return;
               }
               if(!this.wss.peers[id].rtp) {
                  alert('oncallup for id ('+id+') without rtp?');
                  return;
               }
               // connect mic to us
               this.mic.connect(this.wss.peers[id].rtp);
               // connect us to speakers
               this.wss.peers[id].rtp.connect(this.ctx.destination);
               Object.keys(this.wss.peers).forEach((pid) => {
                  if(this.wss.peers[pid].active && this.wss.peers[pid].rtp && pid != id) {
                     // connect our output to all other inputs
                     this.wss.peers[id].rtp.connect(this.wss.peers[pid].rtp);
                     // connect all other outputs to our input
                     this.wss.peers[pid].rtp.connect(this.wss.peers[id].rtp);
                  }
               });
               this.wss.peers[id].rtp.setgain_i(1.0);
               this.wss.peers[id].rtp.setgain_o(1.0); 
         },
         _oncalldown(id) {
            this.active_call = false;
            if(this.wss._stream) {
               console.log('ignore oncalldown when in LITE mode');
               return;
            }
            //alert("oncalldown: " + id);
            if(!(id in this.wss.peers)) {
               alert('oncalldown for id ('+id+') not in peers?');
               return;
            }
            
            if(!this.wss.peers[id].rtp) {
               alert('oncalldown for id ('+id+') without rtp?');
               return;
            }
            this.mic.disconnect(this.wss.peers[id].rtp);
            // disconnect all of our outputs
            this.wss.peers[id].rtp.disconnect();
            Object.keys(this.wss.peers).forEach((pid) => {
               if(this.wss.peers[pid].active && this.wss.peers[pid].rtp && pid != id) {
                  // disconnect all other outputs to our input
                  this.wss.send({cmd:'log', data: this.date+ ' user: '+pid+ ' -> Contacts: _oncalldown : before : disconnect'}); 
                  // this.parentRefs.debug_state.innerHTML +=  'user: '+pid+' -> Contacts: _oncalldown : before : disconnect';
                  this.print_debug('user: '+pid+' -> Contacts: _oncalldown : before : disconnect');
                  console.log('Contacts: _oncalldown : before : disconnect');
                  // alert('_oncalldown : Disconnect in Contacts Component');
                  this.wss.peers[pid].rtp.disconnect(this.wss.peers[id].rtp);
                  // console.log('Contacts: _oncalldown : after : disconnect');
               }
            });            
         },
         muted(name) {
            if (typeof this.muted_by == 'undefined') {
               return {'id': '' ,'state' : 'false'} 
            } else if(name == this.muted_by.mute_by) {
               return this.muted_by
            } else {
               return {'id': '' ,'state' : 'false'}
            }
         },
         _onappmsg(id, cmd, data) {
            if (cmd.cmd) {
               this.muted_by =  {
                  'id': id ,
                  'state' : cmd.data.state,
                  'mute_by' : cmd.data.mute_by
               }
            }
         }
      },
      computed: {
      },
   }
   
</script>

<style scoped>
   .contacts {
/*      overflow-y: scroll;
      height: 80%;
      position: relative;
      bottom: 0;*/
   }
   .row {
      padding: 0px;
      margin:0px;
   }
   .list-group-item {
/*       height: 60px ; */
      padding:  0px;
/*       margin-bottom:6px; */
   }
   .list-group {
/*       height: 100%; */
   }
   .update_state {
      display: None;
   }
   .ative_list{
      margin-bottom: 20px;
      border: 4px solid #00960063;
      overflow-y: scroll;
/*       height: 80%; */
      position: relative;
      bottom: 0;
      height: 140px;
   }
   .disable_layer {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: #faebd78a;
      z-index: 10;
   }
   #card_contacts {
      position: relative;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
      background-color: #fff;
      background-clip: border-box;
      border-radius: .25rem;
   }
   .non_ative_list {
      border: 4px solid #dedbdb;
      overflow-y: scroll;
      height: 80%;
      position: relative;
      bottom: 0;
   }
   .contact_list {
      position: relative;
   }
   
   @media (max-width: 767px) {
      .list-group-item {
/*          margin: 0 0 30px 0; */
      }
   }
   

</style>
